import type { FaireProductEntity } from "../../entity_types/product";

export const p_tj9pxgjf3a: FaireProductEntity = {
  token: "p_tj9pxgjf3a",
  type: "product",
  name: "Beach Tote Market List Notepad",
  brandName: "Island Haus Co",
  imageUrl:
    "https://cdn.faire.com/fastly/c16fa91e4ceecdc80d7552dcd0d69b12c555e646dd87fba235debc6b417a8a55.png",
  priceDollars: 6,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/d6a1980bb8a7e9784ed4ebb6f8f884f6e23243ba12a89adc5c932e68ea0a600e.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
